import FinancialAidApp from '../../internal-owned/portal-financial-aid-v2/App';
import {
  OVERRIDE_GOVERNANCE_REGISTRY,
  TRIEDGE_OVERRIDE_LABELS,
  TRIEDGE_WRAPPER_LABELS,
} from '../../app-shell/overrideGovernance';

export function PortalFinancialAidPage() {
  return (
    <section
      data-testid="parent-portal-financial-aid"
      data-extracted-from="owned:ystnj/parent-portal/financial-aid"
      data-composition-contract="parent-financial-aid-shell-only-v1"
      data-surface-label="parent-financial-aid-source-surface-v1"
      data-triedge-wrapper-label={TRIEDGE_WRAPPER_LABELS.parentFinancialAidSurface}
      data-triedge-wrapper-intent="minimal_composition_host"
      data-triedge-wrapper-status={OVERRIDE_GOVERNANCE_REGISTRY.wrapper_parent_financial_aid_surface.status}
      data-triedge-wrapper-action={OVERRIDE_GOVERNANCE_REGISTRY.wrapper_parent_financial_aid_surface.plannedAction}
      data-triedge-override-label={TRIEDGE_OVERRIDE_LABELS.parentFinancialAidShellOnly}
    >
      <FinancialAidApp />
    </section>
  );
}
